function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 2122 2122",
    style: {
      enableBackground: "new 0 0 2122 2122"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#005B79"
    },
    d: "M1784.799,435.351H395.224c-94.433,0-176.176,96.359-176.176,96.359v0.008 c-32.935,31.167-53.514,75.256-53.514,124.178v586.253c0,94.433,76.553,170.987,170.986,170.987h488.205l164.379,245.506 c17.777,26.551,49.64,33.047,75.05,22.526l0,0l0.002,0c4.014-1.662,7.868-3.74,11.479-6.241 c22.319-12.83,70.457-44.188,82.152-81.835l55.909-179.955h512.4c55.978,0,105.67-26.904,136.861-68.484 c55.112-28.385,92.828-85.801,92.828-152.063V606.336C1955.785,511.904,1879.232,435.351,1784.799,435.351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#259CC6"
    },
    d: "M1726.095,484.901H336.521c-94.433,0-170.986,76.553-170.986,170.986v586.253 c0,94.433,76.553,170.986,170.986,170.986h488.205l164.379,245.506c28.806,43.022,94.618,33.453,109.979-15.991l71.306-229.515 h555.706c94.433,0,170.986-76.553,170.986-170.986V655.886C1897.082,561.454,1820.529,484.901,1726.095,484.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60B5E0"
    },
    d: "M1726.095,484.901H540.408l1141.07,30.498c94.433,0,170.986,76.553,170.986,170.985v586.254 c0,48.947-20.6,93.056-53.563,124.226c58.016-27.348,98.181-86.334,98.181-154.724V655.886 C1897.082,561.454,1820.529,484.901,1726.095,484.901z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0080AC"
    },
    d: "M857.888,1193.417c-11.039-5.791-21.843-12.292-32.418-19.379H712.348v-78.787h25.673 c-21.717-25.349-41.531-53.529-59.042-83.871H425.156v-78.787h215.476c-10.941-27.061-20.157-55.148-27.487-83.87H425.156v-78.787 h172.969c-12.178-96.221-2.307-195.601,36.49-285.036H336.521c-94.433,0-170.986,76.553-170.986,170.985v586.253 c0,94.433,76.553,170.986,170.986,170.986h488.205l164.379,245.506c28.806,43.022,94.618,33.453,109.979-15.991l71.306-229.515 h555.706c94.433,0,170.986-76.553,170.986-170.986v-85.463C1555.977,1291.928,1208.608,1377.382,857.888,1193.417z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.156,
    y: 769.937,
    style: {
      fill: "#FFFFFF"
    },
    width: 1212.304,
    height: 78.787
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.156,
    y: 932.594,
    style: {
      fill: "#FFFFFF"
    },
    width: 1212.304,
    height: 78.787
  }), /*#__PURE__*/React.createElement("rect", {
    x: 712.348,
    y: 1095.251,
    style: {
      fill: "#FFFFFF"
    },
    width: 637.921,
    height: 78.787
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5D2DB"
    },
    d: "M425.156,848.724h187.99c-6.594-25.838-11.654-52.189-15.021-78.787H425.156V848.724z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5D2DB"
    },
    d: "M425.156,1011.381H678.98c-14.4-24.949-27.251-51.342-38.347-78.787H425.156V1011.381z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C5D2DB"
    },
    d: "M712.347,1174.038H825.47c-31.556-21.146-60.931-47.833-87.449-78.787h-25.673V1174.038z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.b329fd35161a2b5c303097fdadef1f8c.svg";
export { ForwardRef as ReactComponent };